import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { DesktopPreview } from './DesktopPreview';
import { MobilePreview } from './MobilePreview';
import { EmptyState } from './EmptyState';
import { Container, DevicePreview, StyledNeutralBanner } from './styles';
import { DISPLAY_CONTENT, Platform } from '../constants';
import { MediaLayoutProp } from '../types';
import { useEmbeddedPreviewContext } from '../context/EmbeddedPreviewContext';

type Props = {
  selectedPlatform: Platform;
} & MediaLayoutProp;

export const Preview = ({ selectedPlatform, mediaLayout }: Props) => {
  const { hasContent: hasRequiredContentFromTemplate } = useEditableFieldsContext();
  const { hasContent: hasRequiredContentFromPreviewValues } = useEmbeddedPreviewContext();

  const hasRenderableContent =
    hasRequiredContentFromTemplate || hasRequiredContentFromPreviewValues;

  const renderPreviewContent = (hasContent: boolean, platform: Platform) => {
    if (!hasContent) return <EmptyState platform={platform} />;
    return platform === Platform.DESKTOP ? (
      <DesktopPreview mediaLayout={mediaLayout} />
    ) : (
      <MobilePreview mediaLayout={mediaLayout} />
    );
  };

  return (
    <Container>
      <DevicePreview platform={selectedPlatform}>
        {renderPreviewContent(hasRenderableContent, selectedPlatform)}
      </DevicePreview>
      <StyledNeutralBanner>{DISPLAY_CONTENT.preview.previewInfo}</StyledNeutralBanner>
    </Container>
  );
};
